/* 30-10 (Remco: "als je paar verwijderd en snel toevoegd dan bugged het want staat 3 producten in de cart terwijl er 2 in
   zetten", "als ik producten verwijder in cart staat er ook error nu"): alle winkelwagenacties (toevoegen, aantal, verwijderen)
   lopen via één wachtrij, in de volgorde van klikken. Zonder wachtrij kwamen antwoorden door elkaar binnen en ging een
   verwijderverzoek op regelnummer naar een regel die intussen verschoven was. */
window.mbCartEnqueue =
  window.mbCartEnqueue ||
  (function () {
    var q = Promise.resolve();
    window.mbCartPending = 0;
    return function (fn) {
      window.mbCartPending++;
      var run = q.then(fn).catch(function () {}).then(function () { window.mbCartPending--; });
      q = run;
      return run;
    };
  })();

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // 30-10: een nog openstaande +/- in de winkelwagen (debounce 300 ms) eerst in de wachtrij, vóór deze toevoeging
        document.querySelectorAll('cart-drawer-items, cart-items').forEach((ci) => {
          if (typeof ci.mbFlush === 'function') ci.mbFlush();
        });

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;
        const linesUpdateDeferred = this.createCartLinesUpdateEvent(variantId, quantity);

        // Snelheid: de winkelwagen meteen openen met een voorlopig kaartje van dit product,
        // in plaats van te wachten op /cart/add (0,4 s, bij de allereerste toevoeging ~1,4 s).
        // De echte inhoud vervangt het kaartje zodra renderContents de drawer opnieuw tekent.
        // Sinds 2026-10-11 eerst "instant": meteen de echte winkelwagen tekenen (mbInstantOpen).
        this.mbOptimisticOpen(formData);
        // 30-10: toevoeging is bij Shopify gelukt -> bij een fout daarna de lade NIET sluiten maar opnieuw ophalen
        // (anders: lade klapt dicht en het product verschijnt pas na verversen).
        let mbAddOk = false;
        if (window.mbCartLog) window.mbCartLog('toevoegen: ' + (this.mbInstant ? 'instant' : this.mbOptimistic ? 'kaartje' : 'zonder voorvertoning'));

        window.mbCartEnqueue(() => fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (window.mbCartLog) window.mbCartLog('antwoord toevoegen: ' + (response.status ? 'FOUT ' + response.status + ' ' + (response.description || '') : 'ok'));
            if (!response.status) mbAddOk = true;
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.mbOptimisticCancel();
              this.handleErrorMessage(response.description);
              this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
              linesUpdateDeferred?.reject(new Error(response.description || response.message));

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              this.resolveCartLinesUpdate(linesUpdateDeferred);
              window.location = window.routes.cart_url;
              return;
            }

            this.resolveCartLinesUpdate(linesUpdateDeferred);

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              const mbAnim = this.mbInstant ? this.mbCaptureAnims() : null;
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
              this.mbOptimisticDone(mbAnim);
            }
          })
          .catch((e) => {
            console.error(e);
            if (window.mbCartLog) window.mbCartLog('fout na toevoegen: ' + ((e && e.message) || e) + (mbAddOk ? ' (product staat er wel in: lade opnieuw ophalen)' : ''));
            if (mbAddOk) {
              this.mbAddRecover();
              return;
            }
            this.mbOptimisticCancel();
            this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
            linesUpdateDeferred?.reject(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          }));
      }

      // ---- Instant winkelwagen (Remco 2026-10-11: "kan je de add to cart instant maken") ----
      // Bij de klik meteen de ECHTE winkelwagen tekenen: productregel, staffelkorting, Suma en de
      // checkoutknop met bedrag, lokaal berekend uit een /cart.js-momentopname (window.mbCartSnap,
      // onderaan dit bestand). Het serverantwoord vervangt dat daarna met dezelfde HTML, dus de klant
      // ziet geen wissel. Staffels = de 4 automatic discounts "Kup 2/3/4/5+" (10/15/20/25%, Amount off
      // order); Shopify rondt die korting naar BENEDEN af op de cent. Wijzigen die kortingen, pas dan
      // MB_TIERS aan. Bij iets onbekends (kortingscode, korting op regelniveau, properties, geen
      // momentopname) valt het terug op het voorlopige kaartje (mbOptimistic, hieronder).
      mbInstantOpen(formData) {
        this.mbInstant = null;
        // 30-10: loopt er nog een winkelwagenactie, dan is de momentopname verouderd: geen instant-weergave
        if (window.mbCartPending > 0) return false;
        const snap = window.mbCartSnap;
        const drawer = this.cart;
        if (!snap || !formData || !drawer || drawer.tagName !== 'CART-DRAWER' || this.closest('quick-add-modal')) return false;
        if (snap.currency && snap.currency !== 'PLN') return false;
        // 2026-10-22: kortingen heten nu "10%", "15%", "20%" (zie MB_TIERS); alleen die mogen al in de winkelwagen staan
        const tierTitles = MB_TIERS.map((t) => t[2]);
        const codeSt = mbCodeState();
        if (codeSt < 0) return false;
        if (codeSt > 0) tierTitles.push(MB_CODE.code);
        if ((snap.cart_level_discount_applications || []).some((d) => !tierTitles.includes(d.title || ''))) return false;
        if ((snap.items || []).some((i) => (i.line_level_discount_allocations || []).length || i.final_line_price !== i.original_line_price)) return false;
        for (const k of formData.keys()) if (/^properties\[|selling_plan/.test(k)) return false;
        const info = this.closest('product-info');
        if (!info) return false;
        let v = null;
        try {
          v = JSON.parse(info.querySelector('variant-selects [data-selected-variant]').textContent);
        } catch (e) {
          return false;
        }
        if (!v || String(v.id) !== String(formData.get('id'))) return false;
        const qty = parseInt(formData.get('quantity')) || 1;
        const sameLines = (snap.items || []).filter((i) => String(i.variant_id) === String(v.id));
        if (sameLines.length > 1) return false;
        const root = drawer.querySelector('#CartDrawer');
        const inner = drawer.querySelector('.drawer__inner');
        const items = drawer.querySelector('cart-drawer-items');
        const wrap = drawer.querySelector('#CartDrawer-CartItems');
        const footer = drawer.querySelector('.cart-drawer__footer');
        const btn = drawer.querySelector('#CartDrawer-Checkout');
        const header = drawer.querySelector('.drawer__header');
        if (!root || !inner || !items || !wrap || !footer || !btn || !header) return false;
        let row = null;
        if (sameLines.length) {
          const inp = wrap.querySelector(`input[data-quantity-variant-id="${v.id}"]`);
          row = inp && inp.closest('tr.cart-item');
          if (!row) return false;
        }

        // Vanaf hier wordt de drawer aangepast; eerst een kopie voor als /cart/add mislukt.
        const bubble = document.getElementById('cart-icon-bubble');
        this.mbInstant = { html: root.innerHTML, empty: drawer.classList.contains('is-empty'), bubble: bubble ? bubble.innerHTML : null };
        try {
          const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
          const fmt = (c) => {
            const [a, b] = (Math.round(c) / 100).toFixed(2).split('.');
            return a.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + b + ' zł';
          };
          const price = v.price;
          const cmp = v.compare_at_price || 0;
          const linePrices = (q) => {
            const line = price * q;
            const cmpLine = cmp * q;
            return {
              html:
                cmp > price
                  ? `<div class="cart-item__discounted-prices"><s class="cart-item__old-price price price--end">${fmt(cmpLine)}</s>
<span class="price price--end">${fmt(line)}</span></div>`
                  : `<span class="price price--end">${fmt(line)}</span>`,
              save: cmpLine > line ? `(Oszczędzasz ${fmt(cmpLine - line)})` : '',
            };
          };
          const icon = (sel, fallback) => {
            const el = drawer.querySelector(sel);
            return el ? el.outerHTML : fallback;
          };

          if (row) {
            // Zelfde variant zat er al in: alleen aantal en regelprijs ophogen.
            const q = (parseInt(sameLines[0].quantity) || 0) + qty;
            const lp = linePrices(q);
            const inp = row.querySelector('.quantity__input');
            if (inp) inp.value = q;
            const pw = row.querySelector('.cart-item__price-wrapper');
            if (pw) pw.innerHTML = lp.html;
            row.dataset.mbLine = String(price * q);
            row.dataset.mbWas = String(Math.max(cmp, price) * q);
          } else {
            const fi = v.featured_image;
            let base = fi && fi.src;
            let alt = (fi && fi.alt) || '';
            let ar = fi && fi.width && fi.height ? fi.width / fi.height : 0;
            const big = v.featured_media && info.querySelector(`media-gallery li[data-media-id$="-${v.featured_media.id}"] img`);
            if (!base) {
              const g = info.querySelector('media-gallery li[data-mb-pos="1"] img') || info.querySelector('media-gallery img');
              if (g) {
                const s = g.getAttribute('src') || '';
                const ver = (s.match(/[?&]v=(\d+)/) || [])[1];
                base = s.split('?')[0] + (ver ? '?v=' + ver : '');
                alt = g.alt || '';
                ar = g.naturalWidth && g.naturalHeight ? g.naturalWidth / g.naturalHeight : 0;
              }
            }
            const url300 = base ? base + (base.includes('?') ? '&' : '?') + 'width=300' : '';
            // Zelfde 300px-bron als de server, zodat de wissel naar de echte regel niet knippert.
            // Is die nog niet binnen, dan eerst de al geladen galerijfoto tonen.
            const pre = mbPreload300(v.id, url300);
            const src = pre && pre.complete && pre.naturalWidth ? url300 : (big && big.currentSrc) || url300;
            const title = ((info.querySelector('.product__title h1') || info.querySelector('.product__title') || {}).textContent || '').trim();
            const url = `${info.dataset.url}?variant=${v.id}`;
            const opts =
              v.title === 'Default Title'
                ? ''
                : '<dl>' +
                  Array.from(info.querySelectorAll('variant-selects fieldset'))
                    .map((f) => f.querySelector('input:checked'))
                    .filter(Boolean)
                    .map((c) => `<div class="product-option rv-cart__opt"><dt>${esc(c.dataset.optionName || (c.name || '').replace(/-\d+\s*$/, '').trim())}:</dt> <dd>${esc(c.value)}</dd></div>`)
                    .join('') +
                  '</dl><p class="product-option"></p>';
            const lp = linePrices(qty);
            const html =
              `<tr class="cart-item mb-instant-row" role="row" data-mb-line="${price * qty}" data-mb-was="${Math.max(cmp, price) * qty}">` +
              `<td class="cart-item__media" role="cell" headers="CartDrawer-ColumnProductImage"><a href="${esc(url)}" class="cart-item__link" tabindex="-1" aria-hidden="true"> </a>` +
              (src ? `<img class="cart-item__image" src="${esc(src)}" alt="${esc(alt)}" width="150" height="${Math.ceil(150 / (ar || 1))}">` : '') +
              `</td>` +
              `<td class="cart-item__details" role="cell" headers="CartDrawer-ColumnProduct"><div class="cart-item__title"><a href="${esc(url)}" class="cart-item__name h4 break">${esc(title)}</a></div><div class="product-option">${fmt(price)}</div>${opts}<ul class="discounts list-unstyled" role="list" aria-label="Rabat"></ul></td>` +
              `<td class="cart-item__totals right" role="cell" headers="CartDrawer-ColumnTotal"><div class="loading__spinner hidden"><svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg></div><div class="cart-item__price-wrapper">${lp.html}</div>${cmp > price ? `<span class="mb-cl-pct">Oszczędzasz ${Math.round(((cmp - price) * 100) / cmp)}%</span>` : ''}</td>` +
              `<td class="cart-item__quantity " role="cell" headers="CartDrawer-ColumnQuantity"><quantity-popover><div class="cart-item__quantity-wrapper quantity-popover-wrapper"><div class="quantity-popover-container"><quantity-input class="quantity cart-quantity">` +
              `<button class="quantity__button" name="minus" type="button" tabindex="-1"><span class="svg-wrapper">${icon('.icon-minus', MB_ICON_MINUS)}</span></button>` +
              `<input class="quantity__input" type="number" value="${qty}" min="0" data-min="1" step="1" tabindex="-1" aria-hidden="true">` +
              `<button class="quantity__button" name="plus" type="button" tabindex="-1"><span class="svg-wrapper">${icon('.icon-plus', MB_ICON_PLUS)}</span></button>` +
              `</quantity-input></div><cart-remove-button><button type="button" class="button button--tertiary cart-remove-button" tabindex="-1"><span class="svg-wrapper">${icon('.icon-remove', MB_ICON_REMOVE)}</span></button></cart-remove-button></div><div class="cart-item__error" role="alert"><small class="cart-item__error-text"></small><span class="svg-wrapper">${icon('.icon-error', MB_ICON_ERROR)}</span></div></quantity-popover></td>` +
              `</tr>`;

            if (!wrap.querySelector('.drawer__cart-items-wrapper')) {
              wrap.insertAdjacentHTML(
                'afterbegin',
                '<div class="drawer__cart-items-wrapper"><table class="cart-items" role="table"><thead role="rowgroup"><tr role="row"><th role="columnheader"></th><th class="caption-with-letter-spacing" scope="col" role="columnheader"></th><th class="right caption-with-letter-spacing" scope="col" role="columnheader"></th><th role="columnheader"></th></tr></thead><tbody role="rowgroup"></tbody></table></div>'
              );
            }
            wrap.querySelector('table.cart-items tbody').insertAdjacentHTML('afterbegin', html);
          }

          // Lege winkelwagen -> gevulde opbouw (zoals de server die tekent)
          const emptyBlock = inner.querySelector('.drawer__inner-empty');
          if (emptyBlock) emptyBlock.remove();
          drawer.classList.remove('is-empty');
          inner.classList.remove('is-empty');
          items.classList.remove('is-empty');
          // Staffelbalk (vervangt de reserveringstimer, Remco 2026-10-22): zelfde HTML als snippets/mb-cart-tiers.liquid
          // Staffelbalk (Remco 2026-10-22; 26-10 even weg en weer terug): zelfde HTML als snippets/mb-cart-tiers.liquid
          {
            const cnt = (snap.item_count || 0) + qty;
            const oldTiers = inner.querySelector('.mb-tiers');
            if (oldTiers) oldTiers.outerHTML = mbTiersHTML(cnt);
            else header.insertAdjacentHTML('afterend', mbTiersHTML(cnt));
          }

          // Totalen + staffelkorting
          const count = (snap.item_count || 0) + qty;
          const hc = header.querySelector('.mb-cl-count');
          if (hc) hc.textContent = String(count);
          const subtotal = (snap.items_subtotal_price || 0) + price * qty;
          const tier = MB_TIERS.find((t) => count >= t[0]);
          const codeOn = mbCodeState() === 1;
          const pct = tier ? tier[1] : codeOn ? MB_CODE.pct : 0;
          const disc = pct ? Math.floor((subtotal * pct) / 100) : 0;
          const chip = tier ? tier[2] : codeOn ? MB_CODE.code : '';
          const total = subtotal - disc;
          // 26-10 (Remco, zoals Bellacombe US): de staffelkorting gaat van de regelprijzen af. Shopify verdeelt de orderkorting naar
          // verhouding over de regels (afgerond op centen).
          // Daarna "Oszczędzasz" = totale besparing (doorstreepprijzen + staffel) met labeltje "10%" (zelfde als snippets/cart-drawer.liquid).
          const rows = Array.from(wrap.querySelectorAll('tr.cart-item'));
          if (rows.some((r) => !r.dataset.mbLine)) throw new Error('mb: regel zonder data-mb-line');
          const lines = rows.map((r) => ({ r, line: parseInt(r.dataset.mbLine, 10) || 0, was: parseInt(r.dataset.mbWas, 10) || 0 }));
          // 30-10: verdeling zoals Shopify (gemeten op 44 winkelwagens): korting x regel / subtotaal naar beneden,
          // restcenten één voor één vanaf de bovenste regel (de oude "grootste rest" zat er soms 1 cent naast).
          const allocs = lines.map((l) => (subtotal ? Math.floor((disc * l.line) / subtotal) : 0));
          let rest = disc - allocs.reduce((a, b) => a + b, 0);
          for (let k = 0; rest > 0 && lines.length; k++, rest--) allocs[k % lines.length]++;
          let base = 0;
          lines.forEach((l, i) => {
            const fin = l.line - allocs[i];
            base += Math.max(l.was, l.line);
            const pw = l.r.querySelector('.cart-item__price-wrapper');
            if (pw)
              pw.innerHTML =
                l.was > fin
                  ? `<div class="cart-item__discounted-prices"><s class="cart-item__old-price price price--end">${fmt(l.was)}</s>\n<span class="price price--end">${fmt(fin)}</span></div>`
                  : `<span class="price price--end">${fmt(fin)}</span>`;
          });
          const saveBox = footer.querySelector('.mb-cl-save');
          if (saveBox) saveBox.innerHTML = mbDiscHTML(disc, chip, fmt, esc);
          const tv = footer.querySelector('.totals__total-value');
          if (tv) tv.textContent = fmt(total);
          btn.removeAttribute('disabled');
          const bt = btn.querySelector('.mb-co__txt');
          if (bt) bt.textContent = `Do kasy • ${fmt(total)}`; // bedrag (Jack & Ruby 23-10), tekst Carlena 26-10
          if (bubble) {
            let cb = bubble.querySelector('.cart-count-bubble');
            if (!cb) {
              bubble.insertAdjacentHTML('beforeend', '<div class="cart-count-bubble"><span aria-hidden="true"></span><span class="visually-hidden"></span></div>');
              cb = bubble.querySelector('.cart-count-bubble');
            }
            const n = cb.querySelector('span[aria-hidden]');
            if (n) n.textContent = count < 100 ? String(count) : '';
          }

          // Tot het serverantwoord: regels niet bedienbaar (regelnummers kloppen nog niet) en een klik
          // op de checkoutknop wachten tot de toevoeging rond is (zie listener onderaan).
          items.inert = true;
          drawer.setAttribute('data-mb-instant', '');
          drawer.open(this.submitButton);
          return true;
        } catch (e) {
          this.mbInstantRestore();
          this.mbInstant = null;
          return false;
        }
      }

      mbInstantRestore() {
        const s = this.mbInstant;
        const d = this.cart;
        if (!s || !d) return;
        const root = d.querySelector('#CartDrawer');
        if (root) root.innerHTML = s.html;
        if (s.empty) d.classList.add('is-empty');
        const b = document.getElementById('cart-icon-bubble');
        if (b && s.bubble != null) b.innerHTML = s.bubble;
        const ov = d.querySelector('#CartDrawer-Overlay');
        if (ov) ov.addEventListener('click', d.close.bind(d));
        d.removeAttribute('data-mb-instant');
        d.mbCheckoutQueued = false;
      }

      // Checkoutknop-animatie (pop/glans/pijl) laten doorlopen als de server de knop vervangt.
      mbCaptureAnims() {
        const b = this.cart && this.cart.querySelector('#CartDrawer-Checkout');
        if (!b || !b.getAnimations) return null;
        const m = {};
        [b, b.querySelector('.mb-co__arrow'), b.querySelector('.mb-co__shine')].forEach((el, i) => {
          if (el) el.getAnimations().forEach((a) => (m[i + '|' + a.animationName] = a.currentTime));
        });
        return m;
      }

      mbRestoreAnims(m) {
        const b = this.cart && this.cart.querySelector('#CartDrawer-Checkout');
        if (!m || !b || !b.getAnimations) return;
        [b, b.querySelector('.mb-co__arrow'), b.querySelector('.mb-co__shine')].forEach((el, i) => {
          if (!el) return;
          el.getAnimations().forEach((a) => {
            const t = m[i + '|' + a.animationName];
            if (t != null) a.currentTime = t;
            else if (a.animationName === 'mb-co-pop') a.finish();
          });
        });
      }

      mbOptimisticOpen(formData) {
        this.mbOptimistic = false;
        try {
          if (this.mbInstantOpen(formData)) return;
        } catch (e) {
          this.mbInstant = null;
        }
        try {
          if (!this.cart || this.cart.tagName !== 'CART-DRAWER' || this.closest('quick-add-modal')) return;
          const inner = this.cart.querySelector('.drawer__inner');
          if (!inner) return;
          const info = this.closest('product-info') || document;
          const img = info.querySelector('media-gallery li.is-active img') || info.querySelector('media-gallery img');
          const titleEl = info.querySelector('.product__title h1') || info.querySelector('.product__title');
          const title = ((titleEl || {}).textContent || '').replace(/\s+/g, ' ');
          const opts = Array.from(info.querySelectorAll('variant-selects fieldset, variant-radios fieldset'))
            .map((f) => {
              const c = f.querySelector('input:checked');
              if (!c) return '';
              // optienaam uit het veld zelf; de legend bevat ook de link naar de maattabel
              const naam = c.dataset.optionName || (c.name || '').replace(/-\d+\s*$/, '').trim();
              return naam + ': ' + c.value;
            })
            .filter(Boolean)
            .join(' · ');
          const price = (info.querySelector('.price__sale .price-item--sale, .price-item--regular') || {}).textContent || '';
          const header = inner.querySelector('.drawer__header');
          const el = document.createElement('div');
          el.className = 'mb-opt';
          el.setAttribute('role', 'status');
          el.setAttribute('aria-live', 'polite');
          // Bij een lege winkelwagen staat de kop (logo) onderaan en het sluitkruisje bovenin; dan het
          // kaartje net onder het kruisje. Anders direct onder de kop.
          const leeg = this.cart.classList.contains('is-empty') || !header || header.offsetTop > inner.clientHeight / 2;
          el.style.top = (leeg ? 64 : header.offsetTop + header.offsetHeight) + 'px';
          el.innerHTML =
            '<div class="mb-opt__row">' +
            (img && img.currentSrc ? '<img class="mb-opt__img" alt="" src="' + img.currentSrc + '">' : '') +
            '<div class="mb-opt__txt"><div class="mb-opt__title"></div><div class="mb-opt__opts"></div><div class="mb-opt__price"></div></div></div>' +
            '<div class="mb-opt__status"><span class="mb-opt__spin" aria-hidden="true"></span><span class="mb-opt__label"></span></div>';
          el.querySelector('.mb-opt__title').textContent = title.trim();
          el.querySelector('.mb-opt__opts').textContent = opts;
          el.querySelector('.mb-opt__price').textContent = price.trim();
          el.querySelector('.mb-opt__label').textContent = document.documentElement.lang === 'pl' ? 'Dodawanie do koszyka…' : 'Adding to cart…';
          inner.appendChild(el);
          this.mbOptimistic = true;
          this.cart.open(this.submitButton);
        } catch (e) {
          this.mbOptimistic = false;
        }
      }

      // 30-10: de toevoeging is gelukt maar het tekenen liep fout: voorvertoning weg, echte lade van de server, lade blijft open.
      mbAddRecover() {
        const d = this.cart;
        this.mbInstant = null;
        this.mbOptimistic = false;
        if (!d) return;
        d.removeAttribute('data-mb-instant');
        d.mbCheckoutQueued = false;
        d.querySelectorAll('.mb-opt').forEach((n) => n.remove());
        const items = d.querySelector('cart-drawer-items');
        if (items) items.inert = false;
        fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
          .then((r) => r.json())
          .then((sections) => {
            if (!sections || !sections['cart-drawer']) return;
            d.classList.toggle('is-empty', /drawer__inner-empty/.test(sections['cart-drawer']));
            d.renderContents({ id: null, sections });
          })
          .catch(() => {});
      }

      mbOptimisticCancel() {
        if (this.mbInstant) {
          this.mbInstantRestore();
          this.mbInstant = null;
          setTimeout(() => {
            if (typeof this.cart.close === 'function') this.cart.close();
          });
          return;
        }
        if (!this.mbOptimistic) return;
        this.mbOptimistic = false;
        this.cart.querySelectorAll('.mb-opt').forEach((n) => n.remove());
        // open() zet 'active' in een setTimeout; sluiten ook een tik later, anders wint het openen
        setTimeout(() => {
          if (typeof this.cart.close === 'function') this.cart.close();
        });
      }

      mbOptimisticDone(anim) {
        if (this.mbInstant) {
          this.mbInstant = null;
          const d = this.cart;
          d.removeAttribute('data-mb-instant');
          this.mbRestoreAnims(anim);
          try {
            if (typeof trapFocus === 'function') trapFocus(document.getElementById('CartDrawer'), d.querySelector('.drawer__inner'));
          } catch (e) {}
          if (d.mbCheckoutQueued) {
            d.mbCheckoutQueued = false;
            const b = document.getElementById('CartDrawer-Checkout');
            if (b) b.click();
          }
          return;
        }
        if (!this.mbOptimistic) return;
        this.mbOptimistic = false;
        this.cart.querySelectorAll('.mb-opt').forEach((n) => n.remove());
        try {
          if (typeof trapFocus === 'function') {
            trapFocus(document.getElementById('CartDrawer'), this.cart.querySelector('.drawer__inner'));
          }
        } catch (e) {}
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response'));
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          })
          .catch((e) => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

// ---- Instant winkelwagen: gedeelde stukken (2026-10-11) ----
// var i.p.v. const: dit bestand kan op één pagina meerdere keren geladen worden.
// Staffels = de automatic discounts op Vesnia (min. aantal, %, titel zoals Shopify hem toont).
// 2026-10-22: in Shopify staan nu 3 automatic discounts "10%" (2+), "15%" (3+), "20%" (4+); de oude "Kup 2..5+" (tot 25%) bestaan niet meer.
var MB_TIERS = [
  [4, 20, '20%'],
  [3, 15, '15%'],
  [2, 10, '10%'],
];
// 30-10: popupcode WITAJ10 (10% op de bestelling, cookie discount_code via /discount/WITAJ10). Telt niet op met de staffel:
// Shopify geeft dan de staffel (gemeten: 1 stuk = code, 2+ = staffel; elke staffel is >= 10%).
// mbCodeState(): 0 = geen code, 1 = WITAJ10, -1 = andere code (dan niet vooraf tekenen, de server tekent).
var MB_CODE = { code: 'WITAJ10', pct: 10 };
function mbCodeState() {
  var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
  if (!m) return 0;
  var c = '';
  try { c = decodeURIComponent(m[1]).trim().toUpperCase(); } catch (e) { return -1; }
  if (!c) return 0;
  return c === MB_CODE.code ? 1 : -1;
}
// 31-10 Remco: labeltje van de staffel zegt erbij dat het de stapelbundelkorting is (zelfde teksten als snippets/cart-drawer.liquid).
var MB_TIER_LABEL = { '10%': 'Kup 2: dodatkowe -10%', '15%': 'Kup 3: dodatkowe -15%', '20%': 'Kup 4+: dodatkowe -20%' };
// Kortingsregel onderaan de lade (30-10, zoals Bellacombe "Discounts"): alleen de echte korting (code of staffel), geen totale besparing.
function mbDiscHTML(disc, chip, fmt, esc) {
  if (!(disc > 0)) return '';
  chip = MB_TIER_LABEL[chip] || chip;
  var icon = typeof MB_ICON_TAG !== 'undefined' ? MB_ICON_TAG : '';
  return '<span class="mb-cl-save__lbl">Rabaty' + (chip ? '<span class="mb-cl-chip">' + icon + esc(chip) + '</span>' : '') + '</span><strong>-' + fmt(disc) + '</strong>';
}
// Staffelbalk in de winkelwagen: exact dezelfde HTML als snippets/mb-cart-tiers.liquid.
function mbTiersHTML(n) {
  var fill = n <= 0 ? '0' : n === 1 ? '16.67' : n === 2 ? '33.33' : n === 3 ? '66.67' : '100';
  var next = n <= 1 ? 10 : n === 2 ? 15 : 20;
  var msg = n >= 4
    ? 'Gratulacje! Otrzymujesz <strong>20% zniżki</strong>!'
    : 'Dodaj jeszcze <strong>1 produkt</strong>, aby otrzymać <strong>' + next + '% zniżki</strong>!';
  var tag = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M21.4 11.6l-9-9A2 2 0 0011 2H4a2 2 0 00-2 2v7c0 .55.22 1.05.59 1.42l9 9a2 2 0 002.82 0l7-7a2 2 0 000-2.82zM6.5 8A1.5 1.5 0 116.5 5a1.5 1.5 0 010 3z"/></svg>';
  var lefts = ['33.33', '66.67', '100'];
  var stops = '';
  for (var i = 1; i <= 3; i++) {
    stops += '<span class="mb-tiers__stop' + (n >= i + 1 ? ' is-done' : '') + '" style="left: ' + lefts[i - 1] + '%">' + tag + '<em>-' + (i * 5 + 5) + '%</em></span>';
  }
  return '<div class="mb-tiers"><p class="mb-tiers__msg">' + msg + '</p><div class="mb-tiers__bar"><span class="mb-tiers__track"></span><span class="mb-tiers__fill" style="width: ' + fill + '%"></span>' + stops + '</div></div>';
}
// Iconen voor een lege winkelwagen (bij een gevulde worden ze uit de drawer zelf gekopieerd).
// Labeltje bij "Oszczędzasz" (26-10), zelfde icoon als in snippets/cart-drawer.liquid.
var MB_ICON_TAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg>';
var MB_ICON_MINUS = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-minus" viewBox="0 0 10 2"><path fill="currentColor" fill-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 1 1 0 1H1A.5.5 0 0 1 .5 1" clip-rule="evenodd"></path></svg>';
var MB_ICON_PLUS = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 10 10"><path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"></path></svg>';
var MB_ICON_REMOVE = '<svg class="icon icon-remove" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true" focusable="false"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14M10 10v7M14 10v7"/></svg>';
var MB_ICON_ERROR = '<svg class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.5" r="5.5" stroke="#fff" stroke-width="2"></circle><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width=".7"></circle><path fill="#fff" d="m5.874 3.528.1 4.044h1.053l.1-4.044zm.627 6.133c.38 0 .68-.288.68-.656s-.3-.656-.68-.656-.681.288-.681.656.3.656.68.656"></path><path fill="#fff" stroke="#EB001B" stroke-width=".7" d="M5.874 3.178h-.359l.01.359.1 4.044.008.341h1.736l.008-.341.1-4.044.01-.359H5.873Zm.627 6.833c.56 0 1.03-.432 1.03-1.006s-.47-1.006-1.03-1.006-1.031.432-1.031 1.006.47 1.006 1.03 1.006Z"></path></svg>';
var MB_ICON_DISCOUNT = '<svg class="icon icon-discount" viewBox="0 0 12 12"><path fill="currentColor" fill-rule="evenodd" d="M7 0h3a2 2 0 0 1 2 2v3a1 1 0 0 1-.3.7l-6 6a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 0-1.4l6-6A1 1 0 0 1 7 0m2 2a1 1 0 1 0 2 0 1 1 0 0 0-2 0" clip-rule="evenodd"></path></svg>';

// De 300px-foto die de winkelwagen gebruikt alvast ophalen, zodat de echte regel niet knippert.
function mbPreload300(variantId, url) {
  if (!url) return null;
  var cache = (window.mbImg300 = window.mbImg300 || {});
  if (!cache[variantId]) {
    var im = new Image();
    im.src = url;
    cache[variantId] = im;
  }
  return cache[variantId];
}

(function () {
  if (window.__mbInstantCartInit) return;
  window.__mbInstantCartInit = true;

  // Klik op de checkoutknop terwijl de toevoeging nog loopt: even vasthouden, daarna doorklikken
  // (anders gaat de klant mogelijk zonder het nieuwe product naar de kassa).
  document.addEventListener(
    'click',
    function (e) {
      var b = e.target && e.target.closest && e.target.closest('#CartDrawer-Checkout');
      var d = b && b.closest('cart-drawer');
      if (!d || !d.hasAttribute('data-mb-instant')) return;
      e.preventDefault();
      e.stopPropagation();
      d.mbCheckoutQueued = true;
      b.classList.add('loading');
    },
    true
  );

  var timer = null;
  function refresh() {
    var url = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c && Array.isArray(c.items)) window.mbCartSnap = c; })
      .catch(function () {});
  }
  function preloadSelected() {
    try {
      var el = document.querySelector('product-info variant-selects [data-selected-variant]');
      var v = el && JSON.parse(el.textContent);
      var s = v && v.featured_image && v.featured_image.src;
      if (s) mbPreload300(v.id, s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=300');
    } catch (e) {}
  }
  function idle(fn) {
    if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 2500 });
    else setTimeout(fn, 1200);
  }
  function init() {
    var d = document.querySelector('cart-drawer');
    if (!d || !document.querySelector('product-info product-form')) return;
    if (d.classList.contains('is-empty')) {
      window.mbCartSnap = { items: [], item_count: 0, items_subtotal_price: 0, cart_level_discount_applications: [], currency: 'PLN' };
    } else {
      idle(refresh);
    }
    idle(preloadSelected);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      // Na elke wijziging opnieuw ophalen; tot dan valt een nieuwe toevoeging terug op het kaartje.
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        window.mbCartSnap = null;
        clearTimeout(timer);
        timer = setTimeout(refresh, 50);
      });
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(preloadSelected, 0); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
